<template>
  <Page title="ダッシュボード" :departmentPath="selectedDepartmentPath">
    <template v-slot:content>
      <DataNotFound v-if="notFound" />
      <div class="container" v-if="!notFound">
        <div class="area-1">
          <div class="uk-card uk-card-default uk-card-body" v-if="chartData.PersonalityMatrix.length">
            性格マトリクス
            <hr />
            <AnalyticsPieChart :chartType="'personality'" :chartData="chartData.PersonalityMatrix" />
          </div>
          <div class="uk-card uk-card-default uk-card-body" v-if="chartData.RDAnalytics.length">
            RD分析
            <hr />
            <AnalyticsPieChart :chartType="'rd'" :chartData="chartData.RDAnalytics" />
          </div>
          <div class="uk-card uk-card-default uk-card-body" v-if="chartData.PMAnalytics.length">
            PM分析
            <hr />
            <AnalyticsPieChart :chartType="'pm'" :chartData="chartData.PMAnalytics" />
          </div>
        </div>
        <div class="area-2">
          <div class="uk-card uk-card-default uk-card-body" v-if="chartData.CulturalFit.length">
            カルチャーフィット
            <hr />
            <div class="wrap">
              <CulturalFitChart :chartData="chartData.CulturalFit" />
            </div>
          </div>
          <div class="uk-card uk-card-default uk-card-body" v-if="chartData.HumanSkill.length">
            ヒューマンスキル
            <hr />
            <HumanSkillChart :chartData="chartData.HumanSkill" />
          </div>
        </div>
        <div class="area-3">
          <div class="uk-card uk-card-default uk-card-body" v-if="chartData.PersonalityActivityMotivation.length">
            性格・行動・意欲
            <hr />
            <TrendSummaryChart :chartData="chartData.PersonalityActivityMotivation" />
          </div>
        </div>
      </div>
    </template>
  </Page>
</template>

<style lang="scss" scoped>
.area-1,
.area-2,
.area-3 {
  display: flex;
  margin-bottom: $spacing-ex-small;
  color: $brand-color;
  font-weight: bold;
  & > div {
    color: $brand-color;
    flex: 1;
    margin: 0 $spacing-small;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .uk-card {
    border: 1px solid $border-color-secondary;
    border-radius: 10px;
    padding: 20px 20px 30px 20px;
  }
}
.area-2 {
  .wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  & > div:last-child {
    flex: 1;
  }
}
hr {
  size: 2px;
  width: 100%;
}
</style>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { RouteLocation } from "vue-router";
import AnalyticsPieChart from "../atoms/AnalyticsPieChart.vue";
import { StatsApi, GetSummaryResponse } from "../../autogen";
import HumanSkillChart from "../atoms/HumanSkillChart.vue";
import TrendSummaryChart from "../atoms/TrendSummaryChart.vue";
import CulturalFitChart from "../molecules/CulturalFitChart.vue";
import DataNotFound from "../atoms/DataNotFound.vue";
import Store from "../../store";
import { InstructionLevel } from "../../types";
import Page from "../molecules/Page.vue";
@Options({
  components: {
    AnalyticsPieChart,
    HumanSkillChart,
    TrendSummaryChart,
    CulturalFitChart,
    DataNotFound,
    Page
  }
})
export default class Dashboard extends Vue {
  private readonly storeInstance = Store.getInstance();
  chartData?: GetSummaryResponse = {
    PersonalityMatrix: [],
    PMAnalytics: [],
    RDAnalytics: [],
    PersonalityActivityMotivation: [],
    HumanSkill: [],
    CulturalFit: []
  };
  departmentId?: string;
  notFound = false;
  selectedDepartmentPath: string = "";
  async draw() {
    this.notFound = false;
    const departmentId = this.$route.params["departmentId"] as string;
    if (this.departmentId === departmentId) return;
    this.departmentId = departmentId;
    try {
      const response = await new StatsApi().getDepartmentSummary({
        departmentId
      });
      this.chartData = response.data;
    } catch (err) {
      this.notFound = true;
      if (err.response.status !== 404) {
        Store.getInstance().setInstructionContent(InstructionLevel.Alert, "エラーが発生しました");
      }
    }
  }
  updated() {
    this.draw();
  }
  mounted() {
    this.draw();
    this.setDepartmentPath();
  }
  @Watch("$route")
  async onRouteChanged(to: RouteLocation) {
    const path = to.path.split("/").filter(Boolean);
    if (path.slice(-1)[0] === "dashboard") {
      this.setDepartmentPath();
    }
  }
  setDepartmentPath() {
    const departmentId = this.$route.params["departmentId"] as string;
    this.selectedDepartmentPath = this.storeInstance.getDepartmentPath(departmentId);
  }
}
</script>
